const packageId = 'sports-bet'

export default [
    // User
    {
        path: `/user/${packageId}/dashboard`,
        name: 'user.sports-bet.dashboard',
        component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/sports-bet/resources/js/pages/user/dashboard`),
    },
    {
        path: `/user/${packageId}/bet-history`,
        name: `user.${packageId}.bet-history`,
        component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageId}/resources/js/pages/user/bet-history`)
    },
    {
        path: `/user/${packageId}/matches`,
        name: `user.${packageId}.matches`,
        component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageId}/resources/js/pages/user/matches`)
    },

    // Admin
    {
        path: `/admin/${packageId}/dashboard`,
        name: `admin.${packageId}.dashboard`,
        component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageId}/resources/js/pages/admin/dashboard`)
    },
    {
        path: `/admin/${packageId}/categories`,
        name: `admin.${packageId}.categories`,
        component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageId}/resources/js/pages/admin/categories`)
    },
    {
        path: `/admin/${packageId}/bets`,
        name: `admin.${packageId}.bets`,
        component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageId}/resources/js/pages/admin/bets`)
    },
    {
        path: `/admin/${packageId}/events`,
        name: `admin.${packageId}.events`,
        component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageId}/resources/js/pages/admin/events`)
    },
    {
        path: `/admin/${packageId}/matches`,
        name: `admin.${packageId}.matches`,
        component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageId}/resources/js/pages/admin/matches`)
    },
    {
        path: `/admin/${packageId}/configuration`,
        name: `admin.${packageId}.configuration`,
        component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageId}/resources/js/pages/admin/configuration`)
    },
    {
        path: `/admin/${packageId}/default-questions`,
        name: `admin.${packageId}.default-questions`,
        component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageId}/resources/js/pages/admin/default-questions`)
    },
    {
        path: `/admin/${packageId}/results`,
        name: `admin.${packageId}.results`,
        component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageId}/resources/js/pages/admin/results`)
    },
]